export const MessageTypes = Object.freeze({
  TextOnly: 106,
  ImageOnly: 107,
  TextImageButton: 108,
  TextButton: 109,
  FileOnly: 220,
  VideoOnly: 230,
  VideoText: 231,
});
